import classNames from 'classnames/bind';
import React from 'react';
import { Button, Text } from '@carnica/ui-kit';
import { IconSearchOutline } from '@carnica/graphics';
import { HeaderThemeView } from "../../store/slices/layout";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var SearchFieldButton = function SearchFieldButton(_ref) {
  var headerTheme = _ref.headerTheme,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    className: cn('component'),
    onClick: onClick,
    size: "m",
    view: HeaderThemeView[headerTheme],
    width: "full"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('content')
  }, /*#__PURE__*/React.createElement(IconSearchOutline, {
    color: HeaderThemeView[headerTheme],
    size: "xs"
  }), /*#__PURE__*/React.createElement(Text, {
    color: HeaderThemeView[headerTheme],
    tagName: "span",
    variant: "body-small"
  }, "\u043D\u0430\u0439\u0442\u0438 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435")));
};